import { RectangleHorizontal, RectangleVertical } from 'lucide-react'
import {
  SearchTagsComboBox,
  SearchTopicsCombobox,
} from '@components/app/panels/right-panel/combo-box'
import {
  TRI_STATE_FILTER_OPTIONS,
  type TrayFilterSegmentOption,
  TrayFilterSegmentRow,
  TraySearchInput,
} from '@components/app/panels/right-panel/tray'
import type { PhotosOrientationFilter } from '@/lib/photos/types/photos-orientation-filter'
import type { PhotosTrayFilters as PhotosTrayFiltersState } from '../hooks/use-photos-tray-filters'

const ORIENTATION_OPTIONS: ReadonlyArray<TrayFilterSegmentOption<PhotosOrientationFilter>> = [
  { value: 'any', label: 'Any', ariaLabel: 'Any orientation' },
  {
    value: 'landscape',
    ariaLabel: 'Landscape',
    icon: <RectangleHorizontal className="size-4" aria-hidden="true" />,
  },
  {
    value: 'portrait',
    ariaLabel: 'Portrait',
    icon: <RectangleVertical className="size-4" aria-hidden="true" />,
  },
]

type PhotosTrayFiltersProps = {
  filters: PhotosTrayFiltersState
  onTopicsOpenChange: (open: boolean) => void
  onTagsOpenChange: (open: boolean) => void
}

/** Controls inside the Photos tray's Filters section: topics, students, filename, segment rows. */
export function PhotosTrayFilters({
  filters,
  onTopicsOpenChange,
  onTagsOpenChange,
}: PhotosTrayFiltersProps) {
  return (
    <>
      <div className="flex flex-col px-4 pb-2 pt-2">
        <SearchTopicsCombobox
          value={filters.selectedTopicTagIds}
          onChange={filters.setSelectedTopicTagIds}
          onOpenChange={onTopicsOpenChange}
        />
      </div>
      <div className="flex flex-col px-4 pb-2 pt-2">
        <SearchTagsComboBox
          value={filters.selectedStudentIds}
          onChange={filters.setSelectedStudentIds}
          onOpenChange={onTagsOpenChange}
        />
      </div>
      <div className="px-4 py-2 pb-4">
        <TraySearchInput
          value={filters.filenameQuery}
          onChange={filters.setFilenameQuery}
          placeholder="Search by filename"
        />
      </div>
      <div className="flex flex-col gap-3">
        <TrayFilterSegmentRow
          label="Orientation"
          value={filters.orientationFilter}
          options={ORIENTATION_OPTIONS}
          onChange={filters.setOrientationFilter}
          className="px-4"
        />
        <TrayFilterSegmentRow
          label="Placed"
          value={filters.placedFilter}
          options={TRI_STATE_FILTER_OPTIONS}
          onChange={filters.setPlacedFilter}
          className="px-4"
        />
        <TrayFilterSegmentRow
          label="Tagged"
          value={filters.taggedFilter}
          options={TRI_STATE_FILTER_OPTIONS}
          onChange={filters.setTaggedFilter}
          className="px-4"
        />
        <TrayFilterSegmentRow
          label="Favorited"
          value={filters.favoritedFilter}
          options={TRI_STATE_FILTER_OPTIONS}
          onChange={filters.setFavoritedFilter}
          className="px-4"
        />
      </div>
    </>
  )
}
